import { debtFundHoldSell } from "../../engine/calculations";
import { TAX_NOTICE } from "../../lib/taxConfig";

const config = {
  key: "debt-fund-hold-sell",
  title: "Debt Fund: Hold or Sell?",
  category: "Tax",
  description: "Compare selling a debt fund now against holding it a few more years, after tax.",
  notice: TAX_NOTICE,
  fields: [
    { key: "currentValue", label: "Current value", type: "currency", default: 5_00_000, min: 0, max: 10_00_00_000 },
    { key: "costBasis", label: "Original investment (cost basis)", type: "currency", default: 4_00_000, min: 0, max: 10_00_00_000 },
    { key: "purchaseDate", label: "Purchase date (YYYY-MM-DD)", type: "text", default: "2023-06-01" },
    { key: "slabRatePct", label: "Your income tax slab rate", type: "percent", default: 30, min: 0, max: 42.74 },
    { key: "expectedAnnualRate", label: "Expected annual return if held", type: "percent", default: 7.5, min: 0, max: 20 },
    { key: "extraHoldYears", label: "Extra years you'd hold", type: "number", default: 3, min: 1, max: 20 },
  ],
  chart: {
    type: "bar",
    xKey: "name",
    series: [{ key: "amount", label: "Amount", colorVar: "--gold" }],
  },
  compute(values) {
    const currentValue = Number(values.currentValue) || 0;
    const costBasis = Number(values.costBasis) || 0;
    const purchaseDate = values.purchaseDate || "2023-06-01";
    const slabRatePct = Number(values.slabRatePct) || 0;
    const expectedAnnualRate = (Number(values.expectedAnnualRate) || 0) / 100;
    const extraHoldYears = Number(values.extraHoldYears) || 0;

    const result = debtFundHoldSell(currentValue, costBasis, purchaseDate, slabRatePct, expectedAnnualRate, extraHoldYears);
    const betterOption = result.advantage > 0 ? "Hold longer" : "Sell now";

    return {
      headline: { label: "Better option", value: betterOption, format: "text" },
      extraHeadlines: [{ label: "Difference in your favour", value: Math.abs(result.advantage) }],
      breakdown: [
        { label: "Sell now, reinvest net proceeds ends with", value: result.sellNowResult },
        { label: `Hold ${extraHoldYears} more years, then sell ends with`, value: result.holdMoreResult },
      ],
      series: [
        { name: "Sell now", amount: result.sellNowResult },
        { name: "Hold longer", amount: result.holdMoreResult },
      ],
    };
  },
};

export default config;
